import { render, staticRenderFns } from "./settingAds.vue?vue&type=template&id=51ff9d6d&scoped=true"
import script from "./settingAds.vue?vue&type=script&lang=js"
export * from "./settingAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff9d6d",
  null
  
)

export default component.exports